if(window.location.pathname.includes('contact')) {
   // FocusIn function to create the label movement effect
   const inputFocusClassesIn = (e) => {

        // Get parent container
        const parentContainer = e.target.closest(".troxy-contact-form__input-and-label");
        // Get the label element within parent
        const label = parentContainer.querySelector("label");

        // Apply reposisiton and focus classes to elements
        label.classList.toggle('focus');
        parentContainer.classList.toggle('focus');
        label.classList.add('reposition');  

        // Show counter if element focused is counter
        if(e.target.nodeName === 'TEXTAREA') {
            document.querySelector('.troxy-contact-form__counter').classList.add('show')
        }

    }

    // FocusOut function to create the label movement effect
    const inputFocusClassesOut = (e) => {

        // Get parent container
        const parentContainer = e.target.closest(".troxy-contact-form__input-and-label");
        // Get the label element within parent
        const label = parentContainer.querySelector("label");
        // Get input value
        const value = e.target.value;

        // Apply reposisiton and focus classes to elements
        label.classList.toggle('focus');
        parentContainer.classList.toggle('focus');

        // If value is empty then reposition the label back into input
        if(value === '') {
            label.classList.remove('reposition');
        }

        // Hide counter if element focused is counter
        if(e.target.nodeName === 'TEXTAREA') {
            document.querySelector('.troxy-contact-form__counter').classList.remove('show')
        }
    }


    const validateAndSubmitContactForm = (formId) => { 
        // Get form
        const form = document.querySelector(`#${formId}`);
        // Create boolean variable to track error
        let isError = false;

        // Create object to hold form data within
        const formData = {
            FNAME: form.querySelector('#mce-FNAME').value,
            LNAME: form.querySelector('#mce-LNAME').value,
            EMAIL: form.querySelector('#mce-EMAIL').value,
            PHONE: form.querySelector('#mce-PHONE').value,
            ENQUIRY: form.querySelector('#mce-ENQUIRY').value,
            gdpr: form.querySelector('#gdpr').checked,
        }

        // Loop through object to check if element has a value
        for(const input in formData) {
            // Get the related error-p tag based on input ID
            const errorP =  form.querySelector(`#error-p__${input}`);

            // If input isn't gdpr as it's a different input type and value is empty
            if(input !== 'gdpr' && formData[input] === '') {
                // Show error-p element 
                errorP.classList.add('show-error');   
                // Set isErrors to true    
                isError = true;        
            } else if (input === 'gdpr' && !formData[input]){
                // If input is gdpr then check if it's not checked
                // If not then show error-p element
                errorP.classList.add('show-error');
            }else {
                // Hide error-p element if input has a value
                errorP.classList.remove('show-error');  
            }
        }

        // If there aren't any errors
        if(!isError) {
            // Find form submit butotn and simulate click to submit form
            const submitBtn = form.querySelector('#troxy-form-submit');
            submitBtn.click();
        }

    }
 

    const onChange = (e) => {

        // Get contact form
        const form = document.querySelector('#mc-embedded-subscribe-form');
        // Get ID from event target
        const id = e.target.id;
        
        // Check if element is gdpr as error-p is in different location
        if(id !== 'gdpr') {
            // Find next sibling which will be error-p and hide error
            const error = e.target.nextSibling.nextSibling;
            error.classList.remove('show-error')        
        } else {
            // Find specfic error-p based on id and hide error
            const error =  form.querySelector(`#error-p__gdpr`);https://www.thinkific.com/
            error.classList.remove('show-error')
        }
    }

    // HANDLING MAILCHIMP FORM SUCCESS RESONSE

    // Get contact form
    const contactForm = document.querySelector('#troxy-contact-form');

    // Create an observer instance to check a mutation in element
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if(mutation.target.classList.contains('sent')) {
                // Hide contact form
                contactForm.classList.add('hide');
                contactForm.classList.remove('sent');
                // Get thank you message and show within dom
                const thankYouMsg = document.querySelector('#troxy-contact-form-thank-you');
                thankYouMsg.classList.add('show');
                // Stop observing
                observer.disconnect();
            }
        });
    });

    // Configuration of the observer
    var config = { attributes: true, childList: true, characterData: true }
   
    // Pass in the target node, as well as the observer options
    observer.observe(contactForm, config);

    const allInputs = [...document.querySelectorAll('.troxy-contact-form__input')];

    allInputs.forEach((input) => {
 
     input.addEventListener("onchange", (event) => onChange(event));
     input.addEventListener("focusin", (event) => inputFocusClassesIn(event));
     input.addEventListener("focusout", (event) => inputFocusClassesOut(event));
     
    })

}